/** модальное окно для выбора локализаций в требуемых случаях */
import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import IntlMessages from "util/intlMessages";
import { adminAPI } from "redux/api";
import { useIntl } from "react-intl";
import { FloatModal } from "components/special";
import FloatCountries from "./FloatCountries";

const { api } = adminAPI.actions;

const FloatCategoriesModal = (props) => {
  const intl = useIntl();
  return (
    <FloatModal
      header={<IntlMessages id="Categories" />}
      {...props}
      // тут хитрая конструкция, которая по умолчанию, если никакого id нет, то ограничивает список по стране null значением
      // иначе если id установлены, то не устанавливает ограничений, чтобы точно искало по всем категориям
      query={{ countryId: _.size(props._id) ? undefined : null, everything: false, ...props.query }}
      head={(search, searchQuery, setSearchQuery) => {
        return (
          <>
            <th>
              <IntlMessages id="name" />
            </th>
            <th>
              <FloatCountries
                _id={searchQuery.categoryId}
                multi={false}
                showTitle={true}
                showCount={false}
                className="btn-sm mr-1"
                successHandler={([countryId = null]) => {
                  setSearchQuery({ ...searchQuery, countryId });
                }}
                intro={intl.formatMessage({ id: "Categories.country" })}
              />
            </th>
            <th style={{ width: "30px" }}></th>
          </>
        );
      }}
      row={(category, clickHandler) => (
        <>
          <td onClick={clickHandler} className={!category.enabled ? "text-strike" : ""}>
            {category.name}
          </td>
          <td onClick={clickHandler} className={!category.enabled ? "text-strike" : ""}>
            {category.country?.name}
          </td>
          <td></td>
        </>
      )}
    />
  );
};

const FloatCategories = (props) => {
  return <FloatCategoriesModal {...props} />;
};
export default connect(null, {
  getData: api.get("/api/references/categories"),
})(FloatCategories);
